export default __webpack_public_path__ + "static/media/transactionIncomplete.88a61882.svg";